module.exports = __webpack_public_path__ + "img/newsDetail.f2cc2cfc.png";